// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__O2knj","loader-38":"Loader_loader-38__hGGr7","backdrop":"Loader_backdrop__BqijE","blur":"Loader_blur__kONRi"};